import { render, staticRenderFns } from "./work-menu-item.vue?vue&type=template&id=63b036ba&scoped=true"
import script from "./work-menu-item.vue?vue&type=script&lang=ts"
export * from "./work-menu-item.vue?vue&type=script&lang=ts"
import style0 from "./work-menu-item.vue?vue&type=style&index=0&id=63b036ba&prod&lang=less&scoped=true"
import style1 from "./work-menu-item.vue?vue&type=style&index=1&id=63b036ba&prod&lang=less"
import style2 from "./work-menu-item.vue?vue&type=style&index=2&id=63b036ba&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b036ba",
  null
  
)

export default component.exports